import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import apis from '../../api'

const ValidateCertificate = () => {

    const [certificate, setCertificate] = useState([])
    const { id } = useParams()

    useEffect(() => {
        const template = async () => {
            await apis.getValidateCertificate(id).then(res => {
                setCertificate(res.data)
            })
        }
        template()
    }, [])

    return (
        <div className="flex flex-wrap align-items-center justify-content-center card-container yellow-container flex-column">
            <div style={
                {
                    marginBottom: "2rem",
                    marginTop: "4rem",
                }
            }
                className="mb-3 font-bold text-4xl flex justify-content-center align-items-center">
                <span className="text-900">Validación carta laboral</span>
            </div>
            <div className='flex flex-wrap card-container flex-column justify-content-start align-items-cemter p-3 m-1'
                style={
                    {
                        backgroundColor: "#1061a2",
                        borderRadius: "20px",
                        border: "1px solid #ccc",
                        width: "40rem"
                    }
                }>
                {Object.keys(certificate).map((key, i) => {
                    return (
                        <div className='flex flex-wrap justify-self-start'>
                            <p key={i}>
                                <span className='text-900 font-bold text-white'>
                                    {key}:&nbsp;
                                </span>
                                <span className='text-900 text-white'>
                                    {certificate[key]}
                                </span>
                            </p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ValidateCertificate;
